module.exports = __webpack_public_path__ + "static/img/loginBg1.e070b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginBg1.png
// module id = 3cGf
// module chunks = 3